<template>
  <div>
    <v-card class="elevation-12">
      <v-toolbar dark color="red darken-1">
        <v-toolbar-title>
          <v-icon left>warning</v-icon>
          Borrar cuenta
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        Una vez que elimines tu cuenta, no hay vuelta atrás.
      </v-card-text>
      <v-card-actions>
        <v-layout wrap align-center justify-center>
          <v-flex xs12 md5>
            <v-dialog persistent v-model="dialog" width="500">
              <template v-slot:activator="{ on }">
                <v-btn color="red darken-1" dark block v-on="on">
                  Borrar tu cuenta
                </v-btn>
              </template>

              <v-card dark>
                <v-card-title class="headline dark red darken-1" primary-title>
                  <v-toolbar-title>
                    <v-icon left>warning</v-icon>
                    Borrar cuenta
                  </v-toolbar-title>
                  <v-spacer />
                  <v-btn
                    flat
                    icon
                    dark
                    @click="dialog = false"
                    :disabled="loading || deleted"
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-alert type="error" dismissible v-model="alert">
                  {{ error }}
                </v-alert>

                <v-card-text v-if="!deleted">
                  Borraremos todos tus datos, además de tus sensores, grupos,
                  edificios y alertas asociadas.
                  <br />
                  Tu nombre de usuario estará disponible para cualquier persona
                  en el portal.
                </v-card-text>

                <v-card-text v-if="deleted">
                  Cuenta borrada con éxito.
                  <br/>
                  <v-btn to="/" dark color="blue">
                    Volver a página principal
                  </v-btn>
                </v-card-text>

                <v-divider></v-divider>
                <form @submit.prevent="deleteAccount" v-if="!deleted">
                  <v-card-text>
                    Introduce tus datos de usuario
                    <v-text-field
                      autofocus
                      required
                      id="email"
                      color="red"
                      prepend-icon="email"
                      name="email"
                      label="Correo electrónico"
                      v-model="email"
                      type="email"
                      counter
                      maxlength="70"
                    ></v-text-field>
                    <v-text-field
                      required
                      id="confirmation"
                      color="red"
                      prepend-icon="mdi-alert-box"
                      name="confirmation"
                      label="Texto de confirmación"
                      autocomplete="off"
                      v-model="confirmation"
                      type="text"
                      hint="Para verificar, escriba <b><i>borrar mi cuenta</i></b> en el campo."
                      pattern="borrar mi cuenta"
                      persistent-hint
                      maxlength="16"
                    ></v-text-field>
                    <v-text-field
                      required
                      id="password"
                      color="red"
                      prepend-icon="lock"
                      name="password"
                      label="Contraseña"
                      v-model="password"
                      type="password"
                      counter
                      maxlength="50"
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-tooltip bottom color="red darken-4">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          block
                          dark
                          color="red darken-1"
                          type="submit"
                          :disabled="disabled"
                          :loading="loading"
                          v-on="on"
                        >
                          Borrar mi cuenta
                        </v-btn>
                      </template>
                      <div class="v-btn__content">
                        <v-icon dark left>warning</v-icon>
                        Esta acción no se puede deshacer
                      </div>
                    </v-tooltip>
                  </v-card-actions>
                </form>
              </v-card>
            </v-dialog>
          </v-flex>
          <v-flex xs12 md7 />
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
//Formulario para borrar la cuenta
// @group Configurar usuario
export default {
  name: "DeleteAccount",
  data() {
    return {
      alert: false,
      dialog: false,
      deleted: false,
      email: "",
      confirmation: "",
      password: ""
    };
  },
  methods: {
    // @vuese
    // Borra la cuenta del usuario del sistema
    // @arg Email y contraseña
    deleteAccount() {
      this.alert = false;
      this.$store
        .dispatch("deleteAccount", {
          email: this.email,
          password: this.password
        })
        .then(() => {
          this.deleted = true;
        })
        .catch(error => {
          this.alert = true;
        });
    }
  },
  computed: {
    // @vuese
    // Desactiva el botón si no se cumplen las condiciones
    disabled() {
      if (
        this.email === "" ||
        this.confirmation !== "borrar mi cuenta" ||
        this.password === "" ||
        this.loading
      ) {
        return true;
      } else {
        return false;
      }
    },
    // @vuese
    // Indica el error
    error() {
      return this.$store.state.error;
    },
    // @vuese
    // Indica si el sistema está cargando
    loading() {
      return this.$store.state.loading;
    }
  },
  watch: {
    alert(value) {
      if (!value) {
        this.$store.commit("setError", null);
      }
    }
  }
};
</script>
